import { jsxs as n, jsx as i } from "react/jsx-runtime";
import { Icon as o } from "@zapier/zinnia-icons";
import { Text as m } from "@zapier/design-system";
const u = "_sidebarSectionTitle_1ccd8_1", d = "_container_1ccd8_6", c = {
  sidebarSectionTitle: u,
  container: d
};
var p = {
  zaps: "Zaps",
  interfaces: "Interfaces",
  tables: "Tables",
  chatbots: "Chatbots"
}, f = function(l) {
  var s = l.requirements;
  return /* @__PURE__ */ n("section", { children: [
    /* @__PURE__ */ i(m, { type: "ParagraphHeader2", className: c.sidebarSectionTitle, tag: "h2", children: "Plan requirements" }),
    /* @__PURE__ */ n("div", { className: c.container, children: [
      /* @__PURE__ */ i("p", { children: "This template includes:" }),
      /* @__PURE__ */ i("ul", { children: Object.entries(s).sort(function(r, t) {
        return r[0].localeCompare(t[0]);
      }).map(function(r) {
        var t = r[0], e = r[1], a = e.current_plan_limit && e.current_plan_limit <= 99999 ? String(Math.max(0, e.current_plan_limit - e.current_count)) : null;
        return /* @__PURE__ */ n("li", { children: [
          /* @__PURE__ */ i(o, { name: "ratingStarFill", size: "15", color: "Purple3" }),
          /* @__PURE__ */ n("span", { children: [
            /* @__PURE__ */ n("strong", { children: [
              p[t],
              ": "
            ] }),
            e.requested_count,
            " (",
            a !== null ? "".concat(a, " remaining") : "Unlimited",
            ")"
          ] })
        ] }, t);
      }) })
    ] })
  ] });
};
export {
  f as PlanRequirements
};
//# sourceMappingURL=PlanRequirements.es.js.map
